// Genvitungu Plus — monthly membership: free delivery + locked best-tier price.
import { MPESA_TILL_NUMBER } from './delivery';
import type { Membership } from '@/types';
import type { PricingSettings } from '@/components/Admin/PriceManager';

export const MEMBER_MONTHLY_PRICE = 499; // KSh / month
export const MEMBER_ORDER_DISCOUNT = 10; // KSh off every member order (plus free delivery)
export const MEMBER_TILL_NUMBER = MPESA_TILL_NUMBER;
export const LAST_MEMBER_PHONE_KEY = 'gv:memberPhone'; // remembers a recognised member

/** Stable lookup key for a phone number (country-normalised digits). */
export function memberKey(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('0') && digits.length === 10) return '254' + digits.slice(1);
  if (digits.startsWith('254')) return digits;
  if (digits.length === 9) return '254' + digits;
  return digits;
}

/** True if the membership is currently active (and not expired). */
export function isMemberActive(m: Membership | null | undefined): boolean {
  if (!m || m.status !== 'active') return false;
  if (m.expiresAt && new Date(m.expiresAt).getTime() < Date.now()) return false;
  return true;
}

/** Member price per kg — the best tier rate regardless of order size. */
export function memberPricePerKg(pricing: PricingSettings): number {
  return pricing.tier3Price;
}
